import axios from 'axios';
import _ from 'lodash';
import { callAirBrake, url } from '../config/apiSetting';
import {
  CONFIRM_UNSUBSCRIBE_FAILED,
  CONFIRM_UNSUBSCRIBE_SUCCESS,
  DATA_ERROR_MSG,
  ERROR_MSG,
  GET_AUTOSUGGEST_DATA,
  GET_DATA,
  GET_ERRORS,
  GET_LOAD_DATA_ERRORS,
  GET_TOTAL_PAGE_SIZE,
  GET_UNIQUE_DATA,
  GET_VERIFIED_SUBSCRIBER_FAILED,
  GET_VERIFIED_SUBSCRIBER_SUCCESS,
  HIDE_LOADING_SPINNER,
  SHOW_LOADING_SPINNER,
  UNSUBSCRIBE_FAIL,
  UNSUBSCRIBE_SUCCESS,
} from '../constants/actionTypes';
import { clearLS, getLS, removeLS, setLS } from '../helpers/utils';


function removeEmpty(obj) {
  if (obj === null || obj === '') {
    return obj;
  }
  Object.keys(obj).forEach((key) => {
    if (obj[key] && typeof obj[key] === 'object') {
      removeEmpty(obj[key]);
    } else if (obj[key] === null || obj[key] === undefined) {
      // eslint-disable-next-line no-param-reassign
      delete obj[key];
    }
  });

  return obj;
}

function urlParamsMerge(url, params) {
  if (params === null || params === '') {
    return url;
  }
  // eslint-disable-next-line no-undef
  return url + (url.indexOf('?') > -1 ? '&' : '?') + $.param(params);
}

export const confirmUnsubscribe = (data, option) => (dispatch) =>
  axios
    .post(
      `${url}/subscriptions/${data}/cc_unsubscribe?confirm=true&option=${option}`,
      {},
      { withCredentials: true }
    )
    .then((res) => {
      if (!res.data.error) {
        dispatch({ type: HIDE_LOADING_SPINNER });
        dispatch({ type: CONFIRM_UNSUBSCRIBE_SUCCESS, payload: res.data });
      } else {
        dispatch({ type: CONFIRM_UNSUBSCRIBE_FAILED, payload: DATA_ERROR_MSG });
        dispatch({ type: HIDE_LOADING_SPINNER });
        callAirBrake(`Error to unsubscribe:${res.data.error}`);
      }
    })
    .catch((err) => {
      dispatch({ type: HIDE_LOADING_SPINNER });
    });

export const getVerifiedSubscriber = (data, option) => (dispatch) =>
  axios
    .post(
      `${url}/subscriptions/${data}/cc_unsubscribe?option=${option}`,
      {},
      { withCredentials: true }
    )
    .then((res) => {
      setLS('dark', false);
      if (!res.data.error) {
        dispatch({ type: HIDE_LOADING_SPINNER });
        dispatch({ type: GET_VERIFIED_SUBSCRIBER_SUCCESS, payload: res.data });
      } else {
        dispatch({ type: GET_VERIFIED_SUBSCRIBER_FAILED, payload: DATA_ERROR_MSG });
        dispatch({ type: HIDE_LOADING_SPINNER });
        callAirBrake(`Error verified subscriber:${res.data.error}`);
      }
    })
    .catch((err) => {
      dispatch({ type: HIDE_LOADING_SPINNER });
    });

export const getUnsubscribe = (data) => (dispatch) => {
  const headerConfig = JSON.parse(getLS('header_token'));

  if (headerConfig) {
    dispatch({ type: SHOW_LOADING_SPINNER });

    return axios
      .post(`${url}/subscriptions/${data.id}/unsubscribe`, {}, { withCredentials: true })
      .then((res) => {
        if (!res.data.error) {
          dispatch({ type: HIDE_LOADING_SPINNER });
          dispatch({ type: UNSUBSCRIBE_SUCCESS, payload: res.data.data });
        } else {
          dispatch({ type: UNSUBSCRIBE_FAIL, payload: DATA_ERROR_MSG });
          dispatch({ type: HIDE_LOADING_SPINNER });
          callAirBrake(`Error getUnsubscribe:${res.data.error}`);
        }
      })
      .catch((err) => {
        dispatch({ type: HIDE_LOADING_SPINNER });
      });
  }
};

export const getFilteredData = (data) => (dispatch) => {
  let totalDataSize = 0;
  const params = {
    filter: data.filters,
    page: {
      size: data.page.size,
      number: data.page.number,
    },
    sort: data.sortField && data.sortOrder === 'desc' ? `-${data.sortField}` : data.sortField,
  };
  const headerConfig = JSON.parse(getLS('header_token'));
  const redefinedParams = removeEmpty(params);
  const redefineUrl = urlParamsMerge(url + data.apiURL, redefinedParams);

  if (headerConfig) {
    dispatch({ type: SHOW_LOADING_SPINNER });

    return axios
      .get(redefineUrl, { withCredentials: true })
      .then((res) => {
        if (!res.data.error) {
          if (data.type === 'suggestionsData') {
            dispatch({ type: GET_AUTOSUGGEST_DATA, payload: res.data.data });
          } else {
            dispatch({ type: GET_DATA, payload: res.data.data });
            if (res.data.meta) {
              if (res.data.data.length === 0 || res.data.data.length < data.page.size) {
                totalDataSize = data.page.number * data.page.size;
              } else {
                totalDataSize = res.data.meta.page_count * data.page.size;
              }
            } else if (res.data.data) {
              totalDataSize = res.data.data.length;
            }
            dispatch({ type: GET_TOTAL_PAGE_SIZE, payload: totalDataSize });
          }
        } else {
          dispatch({ type: GET_LOAD_DATA_ERRORS, payload: DATA_ERROR_MSG });
          dispatch({ type: HIDE_LOADING_SPINNER });
          callAirBrake(`getFilteredData:${res.data.error}`);
        }
      })
      .catch((err) => {
        dispatch({ type: GET_LOAD_DATA_ERRORS, payload: 'Server Error' });
        dispatch({ type: HIDE_LOADING_SPINNER });
      });
  }
};

export const getUniqueData = (data) => (dispatch) => {
  const params = {
    filter: data.filters,
    page: {
      size: data.page.size,
      number: data.page.number,
    },
  };
  const headerConfig = JSON.parse(getLS('header_token'));
  const redefinedParams = removeEmpty(params);
  const redefineUrl = urlParamsMerge(url + data.apiURL, redefinedParams);

  if (headerConfig) {
    return axios
      .get(redefineUrl, { withCredentials: true })
      .then((res) => {
        if (!res.data.error) {
          const uniqData = _.uniqBy(res.data.data, `attributes.${data.apiAttribute}`);
          dispatch({ type: GET_UNIQUE_DATA, payload: uniqData });
        } else {
          dispatch({ type: GET_ERRORS, payload: ERROR_MSG });
          dispatch({ type: HIDE_LOADING_SPINNER });
          callAirBrake(`getUniqueData:${res.data.error}`);
        }
      })
      .catch((err) => {
        dispatch({
          type: GET_ERRORS,
          payload: ERROR_MSG,
        });
      });
  }
};

export function showLoadingSpinner() {
  return {
    type: SHOW_LOADING_SPINNER,
    payload: null,
  };
}

export function hideLoadingSpinner() {
  return {
    type: HIDE_LOADING_SPINNER,
    payload: null,
  };
}
